import { render, staticRenderFns } from "./TabStaticAssets.vue?vue&type=template&id=a4a48dc6"
import script from "./TabStaticAssets.vue?vue&type=script&lang=js"
export * from "./TabStaticAssets.vue?vue&type=script&lang=js"
import style0 from "./TabStaticAssets.vue?vue&type=style&index=0&id=a4a48dc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports